import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const ArrowNarrowRightIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M15.1667 13.3333L18.5 9.99996M18.5 9.99996L15.1667 6.66663M18.5 9.99996H6.5C4.29086 9.99996 2.5 11.7908 2.5 14V15.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};